import DefaultLayout from "@/components/DefaultLayout"
import FeaturedSection from "@/components/FeaturedSection"
import Head from "next/head"
import { useState } from "react"

export default function Topsellernew() {
  interface SeoInfo {
    description: string;
    keywords: string;
    title: string;
  }

  const [seoDescription, setSeoDescription] = useState<SeoInfo>({
    description: "",
    keywords: "",
    title: ""
  })

  // 配置默认排序
  const defaultSort = {
    sortDirection: "DESC",
    sortBy: "addTime"
  }

  return (
    <>
      <Head>
        <title>{`Free Shipping | Free Delivery in Australia on Home Decor Items Outdoor String Lights Camping Sleeping Bags`}</title>
        <meta name="keywords" content={`Free shipping, home decor, outdoor lights, stool, mattress topper, shower head, sleeping bags, curtains, blackout curtains, shoe racks, basketball hoops, free delivery, camping gear, garden lights, outdoor string lights, solar pump, kitchen mat, memory foam mattress topper, cooling mattress topper, solar pond pump`}></meta>
        <meta name="description" content={`Shop at CrazySales to enjoy free and fast online delivery. Discover the biggest selection of home and garden decor items, including mattress toppers, shower heads, string lights, and sleeping bags. `}></meta>
        <meta name="format-detection" content="telephone=no" />
        <meta name="renderer" content="webkit" />
        <meta name="apple-mobile-web-app-title" content="Crazy Sales" />
      </Head>
      <DefaultLayout notStickyNavbar={true}>
        <FeaturedSection type="free-shipping" setSeoDescription={setSeoDescription} defaultSort={defaultSort} />
      </DefaultLayout>
    </>
  )
}